import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import ImageOne from '../../assets/images/BCIT-burnaby-campus.jpg';
import ImageTwo from '../../assets/images/BCIT-Health-Sciences-Centre.jpg';
import ImageThree from '../../assets/images/BCIT-Health-Sciences-Centre-2.jpg';

const HomeCarousel = (props: any) => {
    const slides = [
        {
            link: 'https://www.bcit.ca/',
            image: ImageOne,
        },
        {
            link: 'https://www.bcit.ca/',
            image: ImageTwo,
        },
        {
            link: 'https://www.bcit.ca/',
            image: ImageThree,
        },
    ];

    const settings = {
        speed: 500,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: true,
    };

    return (
        <>
            {slides && slides.length > 0 && (
                <SliderContainer>
                    <Slider {...settings}>
                        {slides.map((o, i) => {
                            return (
                                <div key={i}>
                                    <a href={o.link} target="_blank" rel="noopener">
                                        <Slide>
                                            <img src={o.image} alt="Ad" />
                                        </Slide>
                                    </a>
                                </div>
                            );
                        })}
                    </Slider>
                </SliderContainer>
            )}
        </>
    );
};

export default HomeCarousel;

const SliderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    margin-bottom: 30px;
    /* margin-top: -2em; */

    .slick-slider {
        width: 100%;

        div {
            outline: none;
            border-radius: 10px;
            height: 30vh;
        }
    }

    @media (min-height: 800px) {
        margin-top: -4.5em;

        .slick-slider {
            div {
                height: 32vh;
            }
        }
    }
`;

const Slide = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;

    img {
        margin-bottom: 0;
        width: 100%;
    }

    a {
        width: 100%;
        display: block;
        text-decoration: none;
        max-width: 600px;
        margin: 0 auto;
    }
`;
